import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { MethylationFolateDiagramContent } from "./MethylationFolateDiagram";
import { MethylationFolateKeyContent } from "./MethylationFolateKey";

const SvgMethylationFolateDiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1024}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 860, 1076)}
      viewBox={diagramOnly ? "0 142 1024 860" : "0 0 1024 1076"}
    >
      <g id="methylation-folate-diagram+key" clipPath="url(#clip0_18291_211481)">
        <rect width={1024} height={diagramOnly ? 860 : 1076} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <MethylationFolateKeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 74)` : undefined}>
          <MethylationFolateDiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18291_211481">
          <rect width={1024} height={1076} fill="white" />
        </clipPath>
        <clipPath id="clip1_18291_211481">
          <rect width={1024} height={860} fill="white" transform="translate(0 142)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgMethylationFolateDiagramKey;
